<!-- <div class="card cardAgreement" (click)="goToBenefit()" style="align-items: center;padding: 8px">
     <div class="row fullCard">
          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" style="text-align: center;">
               <p class="agre_title" style="font-size: 65px;">{{benefit.agre_title}}</p>
               <img class="benefitIMG" [src]="URL_DOCS+benefit.agre_path |safeUrl">
          </div>
          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" style="align-self: center;">
               <p class="agreementStyle">{{benefit.agre_description}}</p>
          </div>
     </div>
</div> -->

<!-- 
<div class="card mb-3 cardAgreement" (click)="goToBenefit()" >
     <div class="row g-0">
       <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12" style="display: flex; flex-direction: column;  align-items: center;">
          <p class="agre_title" style="font-size: 65px;">{{benefit.agre_title}}</p>
          <div style="height: 100%; width: auto; display: flex; align-items: center; justify-content: center;">
               <img [src]="URL_DOCS+benefit.agre_path |safeUrl" class=" benefitIMG img-fluid" alt="...">
          </div>
       </div>
       <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12"  style="display: flex; align-items: center;">
         <div class="card-body" style="padding: 0;">
          <p class="agreementStyle">{{benefit.agre_description}}</p>

         </div>
       </div>
     </div>
   </div> -->


   <div class="row row-cols-1 row-cols-md-3 g-4">
     <div class="col d-flex">
       <div class="card mb-3 cardAgreement w-100" (click)="goToBenefit()" style="overflow: hidden;">
   
         <div class="row g-0">
   
           <!-- 🟢 Modo Escritorio (Columna) | Modo Responsive (Parte Superior Centrada) -->
           <div class="col-md-5 p-3 d-flex flex-md-column flex-row align-items-center justify-content-center w-100">
             <p class="agre_title m-0 text-md-center text-center" 
                style="font-size: 40px; text-align: center;">
               {{ benefit.agre_title }}
             </p>
             <img [src]="URL_DOCS + benefit.agre_path | safeUrl" class="benefitIMG img-fluid" 
                  alt="Beneficio" style="max-width: 100px;">
           </div>
   
           <!-- 🔵 Modo Escritorio (Fila) | Modo Responsive (Parte Inferior) -->
           <div class="col-md-7 p-3 text-md-start text-center" style='display: flex; align-items: center;'>
             <div class="card-body p-0"
                  style="max-width: 100%; word-wrap: break-word; overflow-wrap: break-word; white-space: normal;">
               <p class="agreementStyle" style="word-break: break-word;">
                 {{ benefit.agre_description }}
               </p>
             </div>
           </div>
   
         </div>
   
       </div>
     </div>
   </div>
   